.actionCell {
  width: 25%;

  .content {
    display: flex;
    gap: 1em;
  }
}
